import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from "vue";
import DxDataGrid, {
  DxColumn,
  DxFilterRow,
  DxPaging, DxPager,
  DxHeaderFilter,
  DxStateStoring,
  DxButton
} from "devextreme-vue/data-grid";
import { ServiceTeamItem } from "@/services/entities/ServiceTeams/ServiceTeamItem";
import { configureDataGridColumnsOrder } from "@/common/util";
import TeamIcon from "../util/TeamIcon.vue";



export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceTeamTable',
  props: {
  data: { type: Array as () => ServiceTeamItem[], default: () => [] },
},
  emits: ["detail"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const selectedKeys = ref([] as number[]);
const props = __props;
const gridRef = ref();

let isConfigured = false;

function onInitialize(e: { component: any}) {
  gridRef.value = e.component;
}

function  onContentReady(e: any) {
  // ensure default column order
  const defaultOrder = ['id', 'teamName', 'service.blServiceName', 'buttons'];
  if (!isConfigured) {
    configureDataGridColumnsOrder(e, defaultOrder);
    isConfigured = true;
  }
};

function showTeam(e: any) {
    selectedKeys.value = [e.row.data.id];
    emit("detail", e.row.data.id);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DxDataGrid), {
    "hover-state-enabled": true,
    "show-borders": false,
    "data-source": props.data,
    id: "teamGridContainer",
    onInitialize: onInitialize,
    "selected-row-keys": selectedKeys.value,
    "auto-navigate-to-focused-row": true,
    "key-expr": "id",
    onContentReady: onContentReady
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DxFilterRow), { visible: true }),
      _createVNode(_unref(DxHeaderFilter), { visible: true }),
      _createVNode(_unref(DxStateStoring), {
        enabled: true,
        type: "localStorage",
        "storage-key": "teamGridContainer"
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "id",
        "data-type": "string",
        caption: "ID",
        visible: false
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "teamName",
        "data-type": "string",
        caption: "Name"
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "service.blServiceName",
        "data-type": "string",
        caption: "Service"
      }),
      _createVNode(_unref(DxColumn), {
        type: "buttons",
        caption: "Actions",
        width: 70
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DxButton), {
            hint: "Teams",
            "styling-mode": "contained",
            type: "normal",
            onClick: showTeam
          }, {
            default: _withCtx(() => [
              _createVNode(TeamIcon)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(DxPaging), { "page-size": 10 }),
      _createVNode(_unref(DxPager), {
        "show-page-size-selector": true,
        "allowed-page-sizes": [5, 10, 20]
      })
    ]),
    _: 1
  }, 8, ["data-source", "selected-row-keys"]))
}
}

})